import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiServicesService } from '../../beneficiary/services/api-services.service';
import { CompanyService } from 'src/app/services/company.service';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import { ReferenceLibraryService } from 'src/app/services/referenceLibrary.service';
import { ToastrService } from 'ngx-toastr';
import { AttorneyService } from 'src/app/services/attorney.service';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FreeTrialService } from '../free-trial.service';
import { ConfirmationService } from 'primeng/api';
import moment from 'moment';
import {DialogModule} from 'primeng/dialog';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-manage-beneficiary',
  templateUrl: './manage-beneficiary.component.html',
  styleUrls: ['./manage-beneficiary.component.scss']
})
export class ManageBeneficiaryComponent implements OnInit {
  taskType: any[];
  familyType: any[];
  beneficiaryDetails: any[];
  searchInput: string = '';
  searchResult: boolean = false;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Input() companyId;
  dirtyFlag: boolean = false;
  hasDuplicate = false;
  showNoContent: boolean = false;
  observableSubscription$ = new Subject();
  city: any = 'createNew';
  displayBasic: boolean;
  editBtnInviteBene: boolean = false;
  orgeditBtnInviteBene: boolean = true;
  benLivingUS: any;
  createNewBene: FormGroup;
  inviteExternalBeneForm: FormGroup;

  residingUs: boolean = false;
  isSubmitted: boolean = false;
  createNewBeneficiaryFlag: boolean = false;

  visaTypes: ReferenceLibrary[];
  filter = {
    superTaskType: 'IMMPET',
    subTaskType: [],
    visaType: [],
    petitionType: [],
    immClassificationType: [],
    immCategoryType: [],
  }

  inviteSent: any = [];
  createdBeneficiary: any = [];

  gender = [
    {
      name: 'Male',
      label: 'Male',
      value: 'MALE'
    },
    {
      name: 'Female',
      label: 'Female',
      value: 'FEML'
    }
  ]
  disableFields : boolean = false;
  disableFieldsForm = false;
  isUpdateBene = false;
  isUpdateSendInvite = false;
  maxDate: Date;
  countBeneficiarie: any;
  getI: string;

  constructor(
    private apiService: ApiServicesService,
    private companyService: CompanyService,
    private formBuilder: FormBuilder,
    private referenceLibraryService: ReferenceLibraryService,
    private toastr: ToastrService,
    protected store: Store<any>,
    public dialog: MatDialog,
    private attorneyService: AttorneyService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private clientsService: FreeTrialService,
    private confirmationService: ConfirmationService  ) {
   }

  ngOnInit(): void {
    this.maxDate = new Date();
    this.createForm();
    this.countBeneficiarie = this.clientsService.getbeneficiaryCount();
  }

  dialogueInitializer(event, title: string, message: string, buttons: any[]) {
    const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      data: {
        update: { title, message },
        buttons: buttons
      }
    });
    return dialogRef;
  }

  deleteImmigration(input) {
    const title = 'Confirm';
    const message = 'Do you wish to remove this item?';
    const buttons = ['Cancel', 'Delete'];

    this.dialogueInitializer(event, title, message, buttons).afterClosed().subscribe(result => {
      if (result) {
        this.inviteExternalBeneForm.enable();
        this.toastr.success("Beneficiary deleted successfully", 'Success');
        let index = this.inviteSent.indexOf(input);
        this.inviteSent.splice(index, 1);
      }
    });
  }

  private createForm() {
    this.inviteExternalBeneForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      middleName: [''],
      userId: ['', [Validators.required]],
      communicationEmailId: ['', [Validators.required, Validators.email]],
      id: [0]
    });
  }

  private createNewBeneForm() {
    this.createNewBene = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      middleName: [''],
      genderType: ['', [Validators.required]],
      date: ['', [Validators.required]],
      emailId: ['', [Validators.email]],
      immType: ['', [Validators.required]],
      benType: ['', [Validators.required]],
      benLivingUS: [0, [Validators.required]],
      selectedBenType: new FormControl(2),
      hasImmigration: ['', []],
      beneficiaryId: [0]
    });
  }

  getVisaType() {
  }

  getImmType() {
    this.familyType = [];
  }

  getBenType() {
    this.taskType = [];
  }

  // convenience getter for easy access to form fields
  get f() { return this.createNewBene.controls; }
  get f1() { return this.inviteExternalBeneForm.controls; }

  searchBeneficiary(event: any) {
  }

  chooseType() {
    if (this.city === 'createNew') {
      this.createNewBeneficiaryFlag = true;
    } else {
      this.createNewBeneficiaryFlag = false;
      this.createForm();
    }
  }

  sendInvite(data: any) {
    this.city = 'sendInvite';
    this.createNewBeneficiaryFlag = false;
    this.createForm();
    this.inviteExternalBeneForm.patchValue({
      firstName: data.fname,
      lastName: data.lname,
      middleName: data.mname
    })
  }

  editNewBene(data: any) {
    this.isUpdateBene = true;
    this.city = 'createNew';
    this.createNewBeneficiaryFlag = true;
    this.createNewBeneForm();
    this.createNewBene.patchValue({ 
      id:data.companyId,  
      firstName: data.firstName,
      lastName: data.lastName,
      middleName:  data.middleName,
      genderType: data.gender,
      date: data.dob ? moment(data.dob).format('YYYY-MM-DD') : null,
      emailId: data.email,
      immType: data.immTypeToApplyCode,
      benType: data.beneficiaryTypeCode,
      benLivingUS: data.currentlyInUS,
      selectedBenType: data.entryVisa != null ? data.entryVisa.code : '',
      hasImmigration: data.isImmStatusValid != null ? data.isImmStatusValid : '',
      beneficiaryId: data.beneficiaryId       
    });
    this.benLivingUSCheck(data.currentlyInUS);
  }

  editNewsendinvite(data: any, i) {
    // tslint:disable-next-line:no-unused-expression
    this.inviteExternalBeneForm.enable();
    this.editBtnInviteBene = true;
    this.orgeditBtnInviteBene = false;
    localStorage.setItem('i', i);
    this.isUpdateSendInvite = true;
    this.city = 'sendInvite';
    this.createNewBeneficiaryFlag = false;
    this.createForm();
    this.disableFieldsForm = false;

    this.inviteExternalBeneForm.patchValue({
      firstName: data.firstName,
      lastName: data.lastName,
      middleName: data.middleName,
      userId:  data.userId,
      communicationEmailId: data.emailId,
      id: data.linkRequestId
    });
    let index = this.inviteSent.indexOf(data);
  }

  updateInvitelist() {
    let payload = {
      attorneyCreatePetitioner: true,
      beneficiaryTypeCode: "",
      companyId: this.companyId,
      emailId: this.inviteExternalBeneForm.controls.communicationEmailId.value,
      firstName: this.inviteExternalBeneForm.controls.firstName.value,
      id: this.inviteExternalBeneForm.controls.id.value ? this.inviteExternalBeneForm.controls.id.value : 0,
      lastName: this.inviteExternalBeneForm.controls.lastName.value,
      middleName: this.inviteExternalBeneForm.controls.middleName.value,
      userId: this.inviteExternalBeneForm.controls.userId.value,
      immCategoryCode: "GCEB"
    };
   
    // tslint:disable-next-line:only-arrow-functions
    // tslint:disable-next-line:max-line-length
    let idx = this.inviteSent.findIndex(
      elem => elem.emailId === this.inviteExternalBeneForm.controls.communicationEmailId.value);

    let idx1 = this.inviteSent.findIndex(
      elem => elem.userId === this.inviteExternalBeneForm.controls.userId.value);
    this.getI = localStorage.getItem('i');
    this.inviteSent.splice(this.getI, 1);
    this.inviteSent.push(payload);
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    this.dirtyFlag = false;
    this.toastr.success('Info saved successfully', 'Success');
    localStorage.removeItem('i');
    this.clientsService.setbeneficiaryInfo(payload);
    this.orgeditBtnInviteBene = true;
    this.editBtnInviteBene = false;
    this.inviteExternalBeneForm.reset();
    this.disableFieldsForm = true;
    this.clientsService.setbeneficiaryInforray(this.inviteSent);
    if (this.inviteSent.length === this.countBeneficiarie) {
          this.displayBasic = true;
          this.inviteExternalBeneForm.disable();
        }
  }

  confirmDelete(uploadedFile){
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      accept: () => {
        this.deleteFiles(uploadedFile);
      },
      reject: () => {
      }
    });
  }
  
// Only AlphaNumeric with Some Characters [-_ ]
keyPressAlphaNumericWithCharacters(event) {

  var inp = String.fromCharCode(event.keyCode);
  // Allow numbers, alpahbets, space, underscore
  if (/[a-zA-Z0-9-_ ]/.test(inp)) {
    return true;
  } else {
    event.preventDefault();
    CustomErrorToastComponent.showErrorToast(this.toastr, 'Special Character are not allowed');
    return false;
  }
}

  deleteFiles(doc) {
        }

  removeInvite(item) { 
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      accept: () => {
        this.inviteExternalBeneForm.enable();
        this.toastr.success("Beneficiary deleted successfully", 'Success');
        let index = this.inviteSent.indexOf(item);
        this.inviteSent.splice(index, 1);
      },
    });
  }

  confirmDeleteValue (item) {
    this.confirmationService.confirm({
        message: 'Do you want to delete this record?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.deleteBene(item);
        },
        reject: () => {
        }
    });
  }

  deleteBene(item) {
    this.inviteExternalBeneForm.enable();
    this.toastr.success("Beneficiary deleted successfully", 'Success');
    let index = this.inviteSent.indexOf(item);
    this.inviteSent.splice(index);
  }

  removeCreatedBen(item) {  
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      accept: () => {
      },
      reject: () => {
      }
    });
  }

  createBeneFormSub() {
    let payload = {
      undocumentedUserInfo: {
        entryVisaCode: this.createNewBene.controls.selectedBenType.value,
        immTypeToApplyCode: this.createNewBene.controls.immType.value,
        currentlyInUS: parseInt(this.createNewBene.controls.benLivingUS.value),
        isImmStatusValid: parseInt(this.createNewBene.controls.hasImmigration.value)
      },
      firstName: this.createNewBene.controls.firstName.value,
      lastName: this.createNewBene.controls.lastName.value,
      middleName: this.createNewBene.controls.middleName.value,
      email: this.createNewBene.controls.emailId.value,
      beneficiaryTypeCode: this.createNewBene.controls.benType.value,
      gender: this.createNewBene.controls.genderType.value,
      dob: this.createNewBene.controls.date.value,
      companyId: this.companyId,
      attorneyCreatePetitioner: true,
      beneficiaryId: this.createNewBene.controls.beneficiaryId.value ? this.createNewBene.controls.beneficiaryId.value : 0
    };
    this.createdBeneficiary.push(payload);
  }

  getUserDetails(){
  }

  getSendInviteList(){
  }

  inviteExternalBeneFormSub() {
    let payload = {
      attorneyCreatePetitioner: true,
      beneficiaryTypeCode: "",
      companyId: this.companyId,
      emailId: this.inviteExternalBeneForm.controls.communicationEmailId.value,
      firstName: this.inviteExternalBeneForm.controls.firstName.value,
      id: this.inviteExternalBeneForm.controls.id.value ? this.inviteExternalBeneForm.controls.id.value : 0,
      lastName: this.inviteExternalBeneForm.controls.lastName.value,
      middleName: this.inviteExternalBeneForm.controls.middleName.value,
      userId: this.inviteExternalBeneForm.controls.userId.value,
      immCategoryCode: "GCEB"
    };
   
    // tslint:disable-next-line:only-arrow-functions
    // tslint:disable-next-line:max-line-length
    let idx = this.inviteSent.findIndex(
      elem => elem.emailId === this.inviteExternalBeneForm.controls.communicationEmailId.value);

    let idx1 = this.inviteSent.findIndex(
      elem => elem.userId === this.inviteExternalBeneForm.controls.userId.value);

    if (idx !== -1){
       CustomErrorToastComponent.showErrorToast(this.toastr, 'EmailId or UserId is already exists');
    } else if (idx1 !== -1) {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'EmailId or UserId is already exists');
    } else {
      this.inviteSent.push(payload);
      this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
      this.dirtyFlag = false;
      this.toastr.success('Info saved successfully', 'Success');
      this.clientsService.setbeneficiaryInfo(payload);
      this.inviteExternalBeneForm.reset();
      this.disableFieldsForm = true;
      this.clientsService.setbeneficiaryInforray(this.inviteSent);
      if (this.inviteSent.length === this.countBeneficiarie) {
          this.displayBasic = true;
          this.inviteExternalBeneForm.disable();
        }
    }
  }



  editInviteExternalBeneFormSub() {
    this.inviteExternalBeneForm.enable();
    let payload = {
      attorneyCreatePetitioner: true,
      beneficiaryTypeCode: "",
      companyId: this.companyId,
      emailId: this.inviteExternalBeneForm.controls.communicationEmailId.value,
      firstName: this.inviteExternalBeneForm.controls.firstName.value,
      id: this.inviteExternalBeneForm.controls.id.value ? this.inviteExternalBeneForm.controls.id.value : 0,
      lastName: this.inviteExternalBeneForm.controls.lastName.value,
      middleName: this.inviteExternalBeneForm.controls.middleName.value,
      userId: this.inviteExternalBeneForm.controls.userId.value
    };

    this.inviteSent.push(payload);
    this.inviteExternalBeneForm.reset();
  }

  benLivingUSCheck(event) {
    if (event === 1) {
      this.residingUs = true;
    } else {
      this.residingUs = false;
    }
  }

  onPrevious(){

    if (localStorage.getItem("plan") == "Petitioner Plan") {
      this.notify.emit(1);
    } else {
      this.notify.emit(2);
    }
  }

  onNext() {
     if (localStorage.getItem("plan") == 'Petitioner Plan') {
          this.notify.emit(3);
        } else {
          this.notify.emit(4);
        }
  }

  onCancel(){
    if (this.dirtyFlag) {

      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.dirtyFlag = false;
          this.router.navigate([`/login/login/signin`]);
        }
      });

    } else {
      this.router.navigate([`/login/login/signin`]);
    }
  }
}
